import { resolveOrders, resolveOrder, resolveEmailContent } from './resolvers/orders.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.orders', {
            url: '/events/orders?:filtertype&:filtertext',
            component: 'orderList',
            resolve: {
                orders: resolveOrders(),
            },
            roles: ['manager', 'stock', 'orders']
        })
        .state('app.admin.deletedorders', {
            url: '/events/orders/deleted',
            component: 'orderList',
            resolve: {
                deleted: () => true
            },
            roles: ['admin']
        })
        .state('app.admin.order-create', {
            url: '/baskets/create',
            component: 'basketCreate',
            resolve: {
                title: () => 'Create an Order'
            },
            roles: ['manager', 'orders']
        })
        .state('app.admin.order-edit', {
            url: '/events/orders/:order/update?tab',
            component: 'orderSave',
            resolve: {
                order: resolveOrder()
            },
            roles: ['manager', 'stock', 'orders']
        })
        .state('app.admin.email-view', {
            url: '/events/orders/:order/email?template',
            component: 'emailView',
            resolve: {
                emailContent: resolveEmailContent()
            },
            roles: ['manager', 'orders']
        })
        ;
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/order.routes.js